import React, { useState, useMemo } from 'react';
import Layout from 'Layout';
import { Helmet } from 'react-helmet-async';
import HeroSlider from './component/HeroSlider';
import FilterBar from './component/FilterBar';
import StrategySection from './component/StrategySection';
import { STRATEGIES_DATA } from './component/types';

const ExpertCommunity: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPlatform, setSelectedPlatform] = useState('all');

  const filteredStrategies = useMemo(() => {
    return STRATEGIES_DATA.filter((s) => {
      const matchPlatform =
        selectedPlatform === 'all' || s.platform.toLowerCase() === selectedPlatform.toLowerCase();
      const matchSearch =
        searchQuery.trim() === '' ||
        s.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        s.author.toLowerCase().includes(searchQuery.toLowerCase());
      return matchPlatform && matchSearch;
    });
  }, [searchQuery, selectedPlatform]);

  const mt4List = useMemo(() => {
    return filteredStrategies.filter((s) => s.platform === 'MT4');
  }, [filteredStrategies]);

  const mt5List = useMemo(() => {
    return filteredStrategies.filter((s) => s.platform === 'MT5');
  }, [filteredStrategies]);

  const ctraderList = useMemo(() => {
    return filteredStrategies.filter((s) => s.platform === 'cTrader');
  }, [filteredStrategies]);

  return (
    <Layout contentClassName="p-0">
      <Helmet>
        <title>Bảng Điều Khiển Giao Dịch CopyTrader - LUMIR</title>
      </Helmet>

      <div className="min-h-screen bg-[#f4f4f4] text-gray-900 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Top Hero Banner Carousel */}
          <HeroSlider />

          {/* Search & Platform Filter Bar */}
          <FilterBar
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
            selectedPlatform={selectedPlatform}
            onSelectPlatform={setSelectedPlatform}
          />

          {/* Section: MT4 */}
          {(selectedPlatform === 'all' || selectedPlatform === 'MT4') && (
            <StrategySection
              title="Chiến lược MT4 Hàng Đầu"
              description="Các chuyên gia sử dụng nền tảng MetaTrader 4 có hiệu suất tốt nhất."
              buttonLabel="Xem Tất Cả MT4"
              strategies={mt4List}
              onViewAll={() => setSelectedPlatform('MT4')}
            />
          )}

          {/* Section: MT5 */}
          {(selectedPlatform === 'all' || selectedPlatform === 'MT5') && (
            <StrategySection
              title="Chiến lược MT5 Nổi Bật"
              description="Được thiết kế cho sức mạnh của MetaTrader 5 với các chỉ số nâng cao."
              buttonLabel="Xem Tất Cả MT5"
              strategies={mt5List}
              onViewAll={() => setSelectedPlatform('MT5')}
            />
          )}

          {/* Section: cTrader */}
          {(selectedPlatform === 'all' || selectedPlatform === 'cTrader') && (
            <StrategySection
              title="Chuyên gia cTrader"
              description="Lợi nhuận được tối ưu qua thuật toán trên nền tảng cTrader mượt mà."
              buttonLabel="Xem Tất Cả cTrader"
              strategies={ctraderList}
              onViewAll={() => setSelectedPlatform('cTrader')}
            />
          )}

          {/* Empty state */}
          {filteredStrategies.length === 0 && (
            <div className="bg-white rounded-xl p-12 text-center border border-gray-200">
              <div className="text-base font-bold text-gray-900 mb-2">Không tìm thấy chiến lược nào phù hợp</div>
              <p className="text-sm text-gray-500 mb-4">
                Vui lòng thử tìm kiếm bằng từ khoá khác hoặc chọn lại bộ lọc nền tảng.
              </p>
              <button
                onClick={() => {
                  setSearchQuery('');
                  setSelectedPlatform('all');
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
              >
                Xoá bộ lọc
              </button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ExpertCommunity;
